import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import styled from 'styled-components';
import { isSocialLoginUrl } from '../../../../../../../app/src/features/authentication/constants/SocialAuth';
import useMobileBreakpoints from '../../../../../../../common/src/hooks/useMobileBreakpoints';
import { goUp } from '../../../../../../../common/src/utils/cssAnimationsUtils';
import {
  isAskaFlow,
  useFlowsDispatch,
  useFlowsSelector,
} from '../../../../../../../common/src/utils/globalVariables';
import { mq } from '../../../../../../../common/src/utils/styledComponentsUtils';
import { setShowBrokerInfoModal } from '../../../../../store/redux/slices/flowsMetaDataSlice';
import BrokerInfoModal from './BrokerInfoModal';

export const FLOWS_BROKER_INFO_MODAL_HELP_BUTTON =
  'FLOWS_BROKER-INFO-MODAL_HELP-BUTTON';

const BrokerInfoModalContainer: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { t } = useTranslation();
  const flowsDispatch = useFlowsDispatch();
  const showBrokerInfoModal = useFlowsSelector(
    (state) => state.flowsMetaData.showBrokerInfoModal,
  );
  const { pathname } = useLocation();
  const { isLaptop } = useMobileBreakpoints();

  return (
    <>
      <BrokerInfoModal
        setShowModal={(val) => flowsDispatch(setShowBrokerInfoModal(val))}
        showModal={showBrokerInfoModal}
      />
      {isSocialLoginUrl &&
        isLaptop &&
        !pathname.includes('/flows/83882ca1-af11-4776-a92a-793ebf149d42') &&
        !isAskaFlow() && (
          <HelpButton
            id={FLOWS_BROKER_INFO_MODAL_HELP_BUTTON}
            onClick={() => flowsDispatch(setShowBrokerInfoModal(true))}
            isCompanyScan={pathname.includes(
              '/flows/83882ca1-af11-4776-a92a-793ebf149d42',
            )}
          >
            {t('Help')}
          </HelpButton>
        )}
    </>
  );
};

const HelpButton = styled.button<{ isCompanyScan?: boolean }>`
  position: fixed;
  top: 9.6rem;
  right: 1.6rem;
  cursor: pointer;
  background-color: ${({ theme }) => theme.brand.primary};
  color: white;
  font-weight: 500;
  border: none;
  border-radius: 50px;
  padding: 0.8rem 2.4rem;
  z-index: 10;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  transition: 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.brand.light};
  }

  ${mq.laptop} {
    top: unset;
    bottom: ${({ isCompanyScan }) => (isCompanyScan ? '8rem' : '2.4rem')};

    animation: ${goUp} 0.2s;
  }
`;

export default BrokerInfoModalContainer;
